@if (loadError) {
    <div class="alert alert-warning py-2 small" role="alert">
        Dashboard metrics could not be loaded. Try refreshing the page.
    </div>
}

<div class="row mb-3">
    <div class="col-md-4">
        <label class="form-label small text-muted mb-1">Filter by training module</label>
        <select
            class="form-select form-select-sm"
            name="moduleFilter"
            [(ngModel)]="selectedModuleId"
            (ngModelChange)="onModuleFilterChange()"
        >
            <option value="">All modules</option>
            @for (module of availableModules; track module.id) {
                <option [value]="module.id">{{ module.title }}</option>
            }
        </select>
    </div>
    <div class="col-md-8 d-flex align-items-end justify-content-md-end">
        <button type="button" class="btn btn-sm btn-secondary" (click)="refresh()">Refresh</button>
    </div>
</div>

<div class="row g-3 mb-3">
    <div class="col-6 col-lg-3">
        <div class="card h-100">
            <div class="card-body py-3">
                <div class="text-muted small text-uppercase">Total sent</div>
                <div class="fs-3 fw-semibold">{{ metrics.kpi.totalSent }}</div>
            </div>
        </div>
    </div>
    <div class="col-6 col-lg-3">
        <div class="card h-100 border-success border-opacity-25">
            <div class="card-body py-3">
                <div class="text-muted small text-uppercase">Completed</div>
                <div class="fs-3 fw-semibold">{{ metrics.kpi.completed }}</div>
            </div>
        </div>
    </div>
    <div class="col-6 col-lg-3">
        <div class="card h-100 border-warning border-opacity-50">
            <div class="card-body py-3">
                <div class="text-muted small text-uppercase">Pending</div>
                <div class="fs-3 fw-semibold">{{ metrics.kpi.pending }}</div>
            </div>
        </div>
    </div>
    <div class="col-6 col-lg-3">
        <div class="card h-100 border-danger border-opacity-50">
            <div class="card-body py-3">
                <div class="text-muted small text-uppercase">Overdue (7+ days)</div>
                <div class="fs-3 fw-semibold text-danger">{{ metrics.kpi.overdue }}</div>
            </div>
        </div>
    </div>
</div>

<div class="row g-3 mb-3">
    <div class="col-12">
        <div class="card border-danger border-opacity-50">
            <div class="card-body pb-2">
                <div class="d-flex flex-wrap align-items-center gap-2 mb-2">
                    <h5 class="card-title mb-0">Overdue invitations</h5>
                    <span class="badge rounded-pill text-bg-danger">{{ overdueCount }}</span>
                </div>
                @if (metrics.overdueInvites.length === 0) {
                    <p class="text-muted small mb-0">No overdue invitations.</p>
                } @else {
                    <div class="table-responsive">
                        <table class="table table-sm table-hover mb-0">
                            <thead>
                                <tr>
                                    <th>Company</th>
                                    <th>Email</th>
                                    <th>Name</th>
                                    <th>Modules</th>
                                    <th>Status</th>
                                    <th>Invited on</th>
                                    <th class="text-end">Days overdue</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                @for (row of metrics.overdueInvites; track row.inviteId) {
                                    <tr class="table-danger">
                                        <td>{{ row.companyName }}</td>
                                        <td>{{ row.email }}</td>
                                        <td>{{ row.participantName }}</td>
                                        <td>{{ row.moduleTitles }}</td>
                                        <td>{{ row.status }}</td>
                                        <td>{{ row.invitedOn | date: 'mediumDate' }}</td>
                                        <td class="text-end">{{ getDaysOverdue(row) }}</td>
                                        <td>
                                            <button
                                                type="button"
                                                class="btn btn-sm btn-link p-0"
                                                (click)="onViewDetails(row)"
                                            >
                                                View
                                            </button>
                                        </td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                }
            </div>
        </div>
    </div>
</div>

@if (showModuleBreakdown && metrics.byModule.length > 0) {
    <div class="row g-3 mb-3">
        <div class="col-12">
            <div class="card">
                <div class="card-body pb-2">
                    <h5 class="card-title mb-3">By training module</h5>
                    <div class="table-responsive">
                        <table class="table table-sm table-hover mb-0">
                            <thead>
                                <tr>
                                    <th>Module</th>
                                    <th class="text-end">Assigned</th>
                                    <th class="text-end">Completed</th>
                                    <th class="text-end">Pending</th>
                                    <th class="text-end">Overdue</th>
                                </tr>
                            </thead>
                            <tbody>
                                @for (row of metrics.byModule; track row.moduleId) {
                                    <tr>
                                        <td>{{ row.moduleTitle }}</td>
                                        <td class="text-end">{{ row.assigned }}</td>
                                        <td class="text-end">{{ row.completed }}</td>
                                        <td class="text-end">{{ row.pending }}</td>
                                        <td class="text-end">{{ row.overdue }}</td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
}
